import React from 'react';
import { SignupProvider } from '@context/SignupContext';
import { Outlet } from 'react-router-dom';

const SignupLayout = () => (
  <SignupProvider>
    <Outlet /> {/* 중첩된 라우트들을 렌더링 */}
  </SignupProvider>
);

export default SignupLayout;
